import { Skeleton } from "antd-mobile";
import img from "app/img";

export function SkeletorCnt(props: { height: number; minHeight?: number }) {
  return (
    <>
      <Skeleton.Title
        animated
        style={{
          width: "100%",
          height: props.height,
          margin: 0,
          padding: 0,
          minHeight: props.minHeight ? props.minHeight : props.height,
          backgroundColor: "#333",
          borderRadius: 15,
        }}
      />
    </>
  );
}

export function SkeletorImg(props: {
  height: number;
  minHeight?: number;
  style?: any;
}) {
  return (
    <>
      <Skeleton
        // animated
        style={{
          width: "100%",
          height: props.height,
          margin: 0,
          padding: 0,
          minHeight: props.minHeight ? props.minHeight : props.height,
          // backgroundColor: "transparent",
          backgroundColor: "#333",
          backgroundImage: "url(" + img.avatar + ")",
          backgroundSize: 50,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          ...props.style,
        }}
      />
    </>
  );
}
